import { render, staticRenderFns } from "./Kardex.vue?vue&type=template&id=0edb86e6&lang=pug&"
import script from "./Kardex.vue?vue&type=script&lang=js&"
export * from "./Kardex.vue?vue&type=script&lang=js&"
import style0 from "./Kardex.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports